/**
 * Checks if a value is invalidated based on its dirty state, last loaded timestamp, and time-to-live (TTL) duration.
 *
 * @param {boolean} isDirty - Indicates if the value is dirty.
 * @param {number|null} loadedAt - The timestamp when the value was last loaded (in milliseconds). If null, the value is considered invalidated.
 * @param {number} [ttlMinutes=5] - The time-to-live (TTL) duration in minutes. If the time elapsed since the last loaded timestamp exceeds this duration, the value is considered invalidated.
 * @returns {boolean} - True if the value is invalidated, false otherwise.
 */
export function isInvalidated(isDirty, loadedAt, ttlMinutes = 5) {
    return isDirty || !loadedAt || ((Date.now() - loadedAt) / 1000) / 60 >= ttlMinutes;
}
